//
// In-memory observable set when boot recovery restored data the primary blob
// had lost (from the localStorage session mirror, or from the backup blob
// generation). Consumed by RecoveryToast so the user learns the safety net
// fired; repeated firings across sessions indicate a persistence bug.
export type RecoveryKind = 'mirror' | 'backup';

let notice: RecoveryKind | null = null;

type Callback = () => void;
const callbacks: Callback[] = [];

function emit(): void {
  callbacks.forEach((cb) => cb());
}

export function getRecoveryNotice(): RecoveryKind | null {
  return notice;
}

export function subscribeRecoveryNotice(cb: Callback): () => void {
  callbacks.push(cb);
  return () => {
    const idx = callbacks.indexOf(cb);
    if (idx >= 0) callbacks.splice(idx, 1);
  };
}

export function markRecovered(kind: RecoveryKind): void {
  if (notice === kind) return;
  notice = kind;
  emit();
}

export function clearRecoveryNotice(): void {
  if (notice === null) return;
  notice = null;
  emit();
}

// Test-only: reset module state between tests.
export function __resetRecoveryNoticeForTest(): void {
  notice = null;
  callbacks.length = 0;
}
